export default __webpack_public_path__ + "static/media/banner2.d9074b6c.png";